import React, { useState, useRef, useEffect, } from 'react';

import Loader from 'react-loader-spinner';
import Switch from "react-switch";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleUp, faAngleDown, faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { withFirebase } from '../../firebase';


const TournamentForm = (props) => {

    const { onClose, showModal } = props;
    const [ad, setAd] = useState(props.ad);
    const inputFocusRef = useRef();

    useEffect(() => {
        inputFocusRef.current.focus();
        setAd(props.ad)
    }, [props.ad])

    const [saving, setSaving] = useState(false);

    // const imageUrl = ad.imageUrl || '';
    const [title, setTitle] = useState(ad.title || '');
    const [url, setUrl] = useState(ad.url || '');
    const [blocked, setBlocked] = useState(ad.blocked || false);

    const invalid = title === '' || url === '';

    const onSubmit = (e) => {
        e.preventDefault();

        if (!invalid && !saving) {
            setSaving(true);

            let data = {
                title: title,
                url: url,
                blocked: blocked
            };
            props.firebase.adsDoc(ad.uid).update(data)
                // props.firebase.premiumUserDoc(user.uid).update(data)
                .then(() => {
                    setSaving(false);
                    onClose();
                })
                .catch((error) => {
                    setSaving(false);
                    console.log("Error: ", error);
                    showModal("Error", "Ocurrió un error al guardar los datos de la publicidad. Compruebe los datos e intentelo de nuevo.")
                    onClose();
                });
        }
    }

    const imageUrl = (ad && ad.imageUrl) ? ad.imageUrl : process.env.PUBLIC_URL + "/ad_none.png";

    return (
        <div className="">

            <div className="text-center" width="100%" style={{ maxHeight: 200, overflowY: 'auto' }} >
                {/* <div className="" width="100%"  > */}
                <img src={imageUrl} class="img-fluid" alt="Responsive image" />
            </div>

            <form onSubmit={onSubmit}>

                <div className="row m-0">
                    <div className="col row pl-0 pr-0 m-0">

                        <div className="col-12 p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="title">Título:</label>
                            <input ref={inputFocusRef} className="form-control form-control-sm" value={title} type="text"
                                onChange={(e) => setTitle(e.target.value)} id="title" name="title" placeholder="..." />
                        </div>

                        <div className="col-12 p-1">
                            <label className="small text-secondary mb-0 ml-1" htmlFor="url">Enlace:</label>
                            <input className="form-control form-control-sm" value={url} type="url" onChange={(e) => setUrl(e.target.value)} id="url" name="url" placeholder="https://example.com" />
                        </div>

                    </div>

                    <div className="col-12 p-0 d-inline-flex">
                        <label htmlFor="switch" className="align-self-center m-1 small">
                            <span className="mr-1">Bloqueado</span>
                            <Switch
                                onChange={(checked) => setBlocked(checked)}
                                checked={blocked}
                                uncheckedIcon={<p className="small text-white font-weight-bold text-center pt-1">No</p>}
                                checkedIcon={<p className="small text-white font-weight-bold text-center pt-1">Si</p>}
                                onColor="#f44336"
                                offColor="#90a4ae"
                                handleDiameter={16}
                                height={22}
                                width={44}
                                id="switch"
                            />
                        </label>

                        {(!saving) ?
                            <div className="flex-fill d-flex flex-row-reverse p-0 mt-2">
                                <button disabled={invalid} type="submit" className="col-auto btn btn-sm btn-success m-1">Guardar</button>
                                <button onClick={onClose} className="col-auto btn btn-sm btn-secondary m-1">Cancelar</button>
                            </div>
                            :
                            <div className="flex-fill d-flex flex-row-reverse p-0 mt-2">
                                <Loader className=""
                                    type="ThreeDots"
                                    color="#263238"
                                    height={39}
                                    width={50}
                                    timeout={0} />
                            </div>
                        }
                    </div>
                </div>
            </form>
        </div>
    )

}

export default withFirebase(TournamentForm);
